import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { bcStates } from 'common/common/states';
import { BcAuth } from 'common/auth/auth.service';
import { IdentityLoginConfigurationModel } from 'common/api/models/identity-login-configuration.model';

@Injectable({
  providedIn: 'root'
})
export class LoginIdentityGuard implements CanActivate {
  constructor(private _bcAuth: BcAuth,
              private _router: Router) {
  }

  async canActivate(routeSnapshot: ActivatedRouteSnapshot) {
    if (this._isSSORequest(routeSnapshot)) {
      return true;
    }

    if (!this._bcAuth.isIdentityLoginAllowed(routeSnapshot)) {
      return true;
    }

    const identityLoginConfiguration: IdentityLoginConfigurationModel = await this._bcAuth.getIdentityLoginConfiguration();
    if (identityLoginConfiguration.enabled) {
      return this._router.createUrlTree([bcStates.layout.url], { queryParamsHandling: 'preserve' });
    }
    return !identityLoginConfiguration.enabled;
  }

  private _isSSORequest(routeSnapshot: ActivatedRouteSnapshot): boolean {
    const aid: string = routeSnapshot.queryParams.aid;
    const un: string = routeSnapshot.queryParams.un;
    return (!!aid || !!un);
  }
}
